module.exports = __webpack_public_path__ + "img/messages.a0ac6a35.svg";